import React, { useEffect, useState } from "react";
import ApiRequests from "./Pages/APIRequests";
import AbilitiesAnalytics from "./Pages/Abilities";
import ActionsAnalytics from "./Pages/Actions";
import { useNavigate, useParams } from "react-router-dom";
import { RiPriceTag3Line } from "react-icons/ri";
import { HiOutlineDocumentSearch } from "react-icons/hi";
import { PiMagnifyingGlass } from "react-icons/pi";
import { Dropdown } from "react-bootstrap";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const MainAnalytics = ({
    account_id,
    fetchOrgData,
    orgData,
    loadingOrgData
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { an_page } = useParams()
    const [selectedOrg, setSelectedOrg] = useState("")
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [loadingAbilities, setLoadingAbilities] = useState(false)
    const [abilityData, setAbilityData] = useState([])
    const [loadingActions, setLoadingActions] = useState(false)
    const [actionsData, setActionsData] = useState([])
    const [loadingApis, setLoadingApis] = useState(false)
    const [apisData, setApisData] = useState([])

    const handleOrgSelect = (org_id) => {
        setSelectedOrg(org_id)
        getAbilities(org_id)
        getActions(org_id)
    }

    const handleNavPage = (page) => {
        navigate(`/e8console/analytics/${page}`)
    }

    const getAbilities = async (org_id) => {
        setLoadingAbilities(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_abilities_req`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setAbilityData(data.data)
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingAbilities(false);
        }
    };

    const getActions = async (org_id) => {
        setLoadingActions(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_actions_req`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    org_id
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setActionsData(data.data)
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingActions(false);
        }
    };

    const getApis = async () => {
        setLoadingApis(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_api_req`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || "Something went wrong");
            }

            setApisData(data.data)
        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingApis(false);
        }
    };

    useEffect(() => {
        getApis()
        fetchOrgData()
        if (orgData.length > 0) {
            setSelectedOrg(orgData[0].id)
            getAbilities(orgData[0].id)
            getActions(orgData[0].id)
        }
    }, [])

    return (
        <div className="analytics_cont">
            <div className="analytics_cont_header">
                <div className="analytics_cont_header_title">
                    <p className="mainframe_item_title fade-in">{t.analytics.title}</p>
                    {/* <div className="analytics_cont_header_title_btn_cont">
                        <button className="analytics_cont_header_title_btn fade-in"><RiPriceTag3Line /> API Pricing</button>
                        <button className="analytics_cont_header_title_btn fade-in"><HiOutlineDocumentSearch /> Documentation</button>
                    </div> */}
                </div>
                <div className="navigation_btns_analytics">
                    <button className={`navigation_btns_analytics_btn fade-in ${an_page == "api-requests" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("api-requests")}>{t.analytics.api_requests}</button>
                    <button className={`navigation_btns_analytics_btn fade-in ${an_page == "abilities" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("abilities")}>{t.analytics.abilities}</button>
                    <button className={`navigation_btns_analytics_btn fade-in ${an_page == "actions" && "navigation_btns_analytics_btn_selected"}`} onClick={() => handleNavPage("actions")}>{t.analytics.actions}</button>
                </div>
            </div>
            {orgData.length > 0 && an_page != "api-requests" && (
                <div className="org_choise_cont">
                    <div className="org_choise_cont_inner">
                        <Dropdown autoClose={"outside"}>
                            <Dropdown.Toggle
                                as="div"
                                className="select_scope fade-in"
                            >
                                {orgData
                                    .filter(org => selectedOrg === org.id)
                                    .map(org => org.name)
                                    .join(", ") || "Select organization"
                                }
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="custom_dropdown_menu">
                                <div className="dropdown_container fade-in">
                                    {orgData.map((singleOrgData) => (
                                        <button
                                            key={singleOrgData.id}
                                            onClick={() => handleOrgSelect(singleOrgData.id)}
                                            className={`settings_link ${selectedOrg == singleOrgData.id && "settings_link_selected"}`}
                                        >
                                            {singleOrgData.name}
                                        </button>
                                    ))}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>

                    </div>
                    <div className="org_choise_cont_last">
                    </div>
                </div>
            )}

            <div className="analytics_cont_body">
                {an_page == "api-requests" && (
                    <ApiRequests
                        account_id={account_id}
                        data={apisData}
                        loading={loadingApis}
                    />
                )}

                {an_page == "abilities" && (
                    <AbilitiesAnalytics
                        data={abilityData}
                        loading={loadingAbilities}
                    />
                )}

                {an_page == "actions" && (
                    <ActionsAnalytics
                        data={actionsData}
                        loading={loadingActions}
                    />
                )}
            </div>
        </div>
    )
}

export default MainAnalytics